import { ChatPage } from "@pages/ChatPage";
import { CenteredLoadingSpinner } from "@shared/components/CenteredLoadingSpinner";
import { useIsCrmEnabled } from "@shared/access-control/useIsCrmEnabled";
import { Navigate, useLocation } from "react-router";

export function RootChatEntry() {
  const { state } = useLocation();
  const isCrmEnabled = useIsCrmEnabled();

  if (isCrmEnabled === null) {
    return <CenteredLoadingSpinner />;
  }

  if (isCrmEnabled !== true) {
    return <Navigate to="/new" replace state={state} />;
  }

  return <ChatPage view="focus" />;
}
